import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function ExclamationPoint({ color = 'icon.primary', pointColor = 'bg.dividerLine', ...props }) {
  return (
    <IconBase viewBox="0 0 16 16" {...props}>
      <Circle cx="8" cy="8" r="8" fill={color} />
      <Path
        d="M7.079 13V6.123H8.925V13H7.079ZM7.989 4.706C7.63367 4.706 7.35633 4.61933 7.157 4.446C6.95767
      4.27267 6.858 4.02567 6.858 3.705C6.858 3.41033 6.95767 3.172 7.157 2.99C7.365 2.79933 7.64233
      2.704 7.989 2.704C8.34433 2.704 8.62167 2.795 8.821 2.977C9.02033 3.15033 9.12 3.393 9.12 3.705C9.12
      4.00833 9.016 4.251 8.808 4.433C8.60867 4.615 8.33567 4.706 7.989 4.706Z"
        fill={pointColor}
      />
    </IconBase>
  )
}

ExclamationPoint.propTypes = {
  color: PropTypes.string,
  pointColor: PropTypes.string,
}

export default ExclamationPoint
